import { getTimezones } from './requests';

export default {
  getTimezones,
};
